<div class="modal-content-attention modal-content-attention-success">
  <div class="modal-content-container">
    <div class="modal-icon modal-icon-success"></div>

    <div class="modal-title">Token Generated</div>

    <div class="modal-message">Access token has been generated successfully.</div>

    <div class="flex flex-col gap-2 border border-skeleton px-4 py-3 rounded-lg w-full mt-4 break-anywhere">
      <div>
        <div class="text-font-secondary">Access Token:</div>
        <div class="font-semibold text-base break-all">{{ accessToken }}</div>
      </div>
      <div class="flex flex-1 justify-center mt-2">
        <div class="relative">
          <button rktButton btnType="secondary" class="!px-3 !py-2" (click)="copyToClipboard()">Copy</button>

          @if (copyFlag) {
            <div class="absolute left-full flex gap-1 items-center top-[0.625rem] text-nowrap ml-3">
              <rkt-icon name="check" class="text-[#43CA21] shrink-0 text-xl"></rkt-icon>Copied to clipboard
            </div>
          }
        </div>
      </div>
    </div>

    <div class="modal-buttons">
      <button rktButton title="Done" (click)="activeModal.close(true)">Done</button>
    </div>
  </div>
</div>
